var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 36,
    viewBox: "0 0 93 52",
    fill: "#6B758B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 51,
    rx: 9,
    fill: "#283C51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.75 24.8572L53.25 29.4286H48.75L44.8125 33.4286V29.4286H39.75V12.2858H57.75V24.8572Z",
    fill: "#283C51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.625 10L33 15.7143V36.2857H39.75V42L45.375 36.2857H49.875L60 26V10H38.625ZM57.75 24.8571L53.25 29.4286H48.75L44.8125 33.4286V29.4286H39.75V12.2857H57.75V24.8571Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.375 16.2858H52.125V23.1429H54.375V16.2858Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1875 16.2858H45.9375V23.1429H48.1875V16.2858Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 32,
    fill: "white",
    transform: "translate(33 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.f9a7926833fb8881073a5d0a64e714f2.svg";
export { ForwardRef as ReactComponent };